import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormBuilder} from '@angular/forms';
import {ToMajorPipe} from '../../../sdk/pipe/to-major.pipe';

@Component({
    selector: 'app-cancel-payment',
    templateUrl: './cancel-payment.component.html',
    styleUrls: ['./cancel-payment.component.scss'],
    standalone: false
})
export class CancelPaymentComponent implements OnInit
{

    title: string;
    message: string;
    @Input()
    amount: string;
    @Input()
    name: string;
    btnOkText: string;
    btnCancelText: string;
    maxCharLength: number = 100;
    submitted = false;
    majorPipe;

    constructor(private activeModal: NgbActiveModal, formBuilder: UntypedFormBuilder, majorPipe: ToMajorPipe)
    {
        this.majorPipe = majorPipe;
        this.title = 'Cancel request to pay transaction';
        this.btnOkText = 'Yes';
        this.btnCancelText = 'Close';

    }

    ngOnInit()
    {
        this.message = `Are you sure you wish to cancel request to pay transaction for R ${this.majorPipe.transform(
            this.amount)} to ${this.name}?`;
    }

    public accept()
    {
        this.submitted = true;

        this.activeModal.close(true);
    }

    public decline()
    {
        this.activeModal.close(false);
    }

    public dismiss()
    {
        this.activeModal.dismiss(false);
    }
}